export const SITE = {
  name: "Isabella Rubino",
  initials: "IR",
  role: "Creative Director & Brand Storyteller",
  location: "Florence, Italy",
  email: "rubinoisabellaa@gmail.com",
};

export const NAV_LINKS = [
  { id: "work", label: "Work" },
  { id: "about", label: "About" },
  { id: "contact", label: "Contact" },
];

export const HERO = {
  headline: "Creative Director\n& Brand Storyteller.",
  subheading:
    "I shape the language of luxury brands — from a single product name to an entire brand universe. Based in Florence, working globally.",
};

const PORTFOLIO_DECK_URL =
  "https://customer-assets.emergentagent.com/job_cargo-creative/artifacts/rrp83304_PORTFOLIO%20IR2025%20%281%29.pptx";

export const PROJECTS = [
  {
    index: "01",
    year: "2023 — Present",
    category: "Product naming & campaign",
    title: "Golden Goose — Sneaker Narratives",
    description:
      "Naming and storytelling for luxury sneaker launches, collaborations, and seasonal campaigns across print and digital.",
    image: "/portfolio/image15.png",
    alt: "Golden Goose sneakers — campaign still",
    span: "large",
    link: "/work/golden-goose",
    linkLabel: "View project",
  },
  {
    index: "02",
    year: "2021 — Present",
    category: "Press & editorial",
    title: "Pitti Immagine — International Communications",
    description:
      "Editorial direction and press adaptation across Pitti Uomo, Pitti Filatti, Taste, and Danzainfiera for international audiences.",
    image: "/portfolio/pitti-pool.jpg",
    alt: "Pitti Uomo 110 — The Pitti Pool campaign",
    span: "small",
    link: "/work/pitti-immagine",
    linkLabel: "View project",
  },
  {
    index: "03",
    year: "2022 — 2024",
    category: "Tone of voice & long-form copy",
    title: "Woolrich × Manteco — Heritage Repositioning",
    description:
      "Brand narrative and landing-page storytelling for a heritage outerwear collaboration — sustainable Italian wool, recycled military fibers, and a contemporary global audience.",
    image: "/portfolio/image22.png",
    alt: "Yellow wool textile — Woolrich Manteco",
    span: "small",
    link: "/work/woolrich-manteco",
    linkLabel: "View project",
  },
  {
    index: "04",
    year: "2020 — 2023",
    category: "Long-form editorial",
    title: "LuisaViaRoma — LVRSustainable",
    description:
      "Editor and content lead at LuisaViaRoma — and one of the editorial voices that shaped LVRSustainable from day one. Long-form interviews with Gabriela Hearst, Antonin Tron, and others on sustainability and the future of fashion.",
    image: "/portfolio/image6.png",
    alt: "LuisaViaRoma editorial — runway look",
    span: "large",
    link: "/work/lvr-sustainable",
    linkLabel: "View project",
  },
  {
    index: "05",
    year: "Ongoing",
    category: "Copy & brand language",
    title: "VGO Associates — Art, Design & Alchemy",
    description:
      "Words for a global gallery working in the dialogue between art, architecture, design and alchemy — radical bespoke projects, collectible objects, and holistic interiors.",
    image: "/portfolio/vgo-gallery.jpg",
    alt: "VGO Associates — gallery project",
    span: "small",
    link: "https://www.vgo-associates.com/",
    linkLabel: "Visit site",
  },
];

export const ABOUT = {
  portrait: null,
  quote:
    "Storytelling isn't about selling. It's about what stays with you after the words fade.",
  body: [
    "I'm a freelance Creative Director and Brand Storyteller with over a decade of experience working with luxury and contemporary fashion brands.",
    "I build the frameworks that make copy possible — defining how a brand sounds, what it stands for, and how it speaks to the people it wants to reach.",
    "My work spans product naming, campaign storytelling, tone of voice development, editorial direction, and press communication.",
    "Bilingual English / Italian. Deep roots in Florence, with a global perspective.",
  ],
  personal:
    "I think best on walks through Florence, with an espresso in hand and a notebook in my pocket.",
  clients: [
    "Golden Goose",
    "Pitti Immagine",
    "Woolrich",
    "LuisaViaRoma",
    "WonderGlass",
  ],
  disciplines: [
    "Brand Strategy",
    "Tone of Voice",
    "Product Naming",
    "Editorial Direction",
    "Campaign Storytelling",
    "Press Communication",
  ],
};

export const CONTACT = {
  heading: "Let's work\ntogether.",
  subtext:
    "Open to creative direction, brand strategy, and tone of voice projects.",
  email: "rubinoisabellaa@gmail.com",
};

export const ON_AI = {
  chapter: "(03) — Manifesto",
  kicker: "On AI",
  lines: [
    "Everyone's using it.",
    "Most of the writing on the internet now reads like the same person wrote it.",
  ],
  statement: "Optimization is cheap.",
  punch: "A point of view is the new luxury.",
  closing:
    "The tools are welcome here. The voice stays mine — every word chosen by a person, on purpose.",
};
